import { createLocalClient } from "./store";

export { createLocalClient, STORAGE_KEY, DEMO_ADMIN_KEY } from "./store";
export { createSeedData, IDS } from "./seed";
export type { LocalSupabaseClient } from "./store";
export type { LocalDb, TableName, DbRow, DbInsert, DbUpdate } from "./seed";
export {
  dbBool,
  dbNullableText,
  dbNumber,
  dbNumberList,
  dbText,
} from "./row-utils";

export const supabase = createLocalClient();
